module.exports = __webpack_public_path__ + "media/images/sp/visit_reservations_enpou/main_visual_nara-d0f6bcc7b2ff8387ce54b1dada47d038.jpg";